import { useState, useEffect } from 'react'
import styles from './HomePaymentReports.module.css'
import { API_BASE_URL, getImageUrl } from '../config'

interface ReportItem {
  id: number
  title: string
  thumbnail: string
  sort_order: number
}

const HOME_REPORT_LIMIT = 6

const DownArrowIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" className={styles.arrow}>
    <path d="M6 9l6 6 6-6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
)

const HomePaymentReports = ({ isExpanded = true, onToggle, onReportsClick, onReportClick }: {
  isExpanded?: boolean
  onToggle?: () => void
  onReportsClick?: () => void
  onReportClick?: (reportId: number) => void
}) => {
  const [reports, setReports] = useState<ReportItem[]>([])

  useEffect(() => {
    const fetchReports = async () => {
      try {
        const response = await fetch(`${API_BASE_URL}/api/home/reports`)
        const result = await response.json()
        if (result.success) {
          setReports(result.data)
        }
      } catch (error) {
        console.error('Failed to fetch reports:', error)
      }
    }
    fetchReports()
  }, [])

  const handleCardClick = (reportId: number) => {
    onReportClick?.(reportId)
  }

  return (
    <div className={styles.container} style={{ backgroundColor: isExpanded ? '#fff' : '#f7f7f7' }}>
      <div className={styles.header} onClick={onToggle}>
        <div className={styles.headerLeft}>
          <div className={styles.iconContainer}>
            <svg viewBox="0 0 20 20" className={styles.icon}>
              <path d="M3 3h14v14H3V3z" fill="none" stroke="currentColor" strokeWidth="1.5"/>
              <path d="M7 7h6M7 10h6M7 13h4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
            </svg>
          </div>
          <div className={styles.textContainer}>
            <h3 className={styles.title}>支付报告</h3>
            <p className={styles.subtitle}>行业洞察与数据分析</p>
          </div>
        </div>
        <div className={`${styles.arrowContainer} ${isExpanded ? styles.expanded : ''}`}>
          <DownArrowIcon />
        </div>
      </div>

      {isExpanded && (
        <div className={styles.content}>
          <div className={styles.cardScroller}>
            <div className={styles.cardGrid}>
              {reports.slice(0, HOME_REPORT_LIMIT).map((report) => (
                <button
                  key={report.id}
                  type="button"
                  className={styles.card}
                  onClick={() => handleCardClick(report.id)}
                >
                  <div className={styles.cardImage}>
                    {report.thumbnail && <img src={getImageUrl(report.thumbnail)} alt="" />}
                  </div>
                </button>
              ))}
            </div>
          </div>
          <button type="button" className={styles.moreButton} onClick={onReportsClick}>
            <span>查看更多</span>
          </button>
        </div>
      )}
    </div>
  )
}

export default HomePaymentReports
